/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type RTMMonitoringPriority = typeof RTMMonitoringPriority[keyof typeof RTMMonitoringPriority];


export const RTMMonitoringPriority = {
  Stable: 'Stable',
  Watch: 'Watch',
  NeedsReview: 'NeedsReview',
} as const;
